class HttpResponse {
  public statusCode: number;
  public message: string;
}

export default HttpResponse;
